"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { LogOut } from "lucide-react";
import { useTranslations } from "@/hooks/useTranslations";

export default function LogoutButton() {
  const { t } = useTranslations("translation");
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();

  const handleLogout = async () => {
    setIsLoading(true);

    try {
      const res = await fetch("/api/logout", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      if (res.ok) {
        router.push("/login");
        router.refresh();
      } else {
        console.error("Logout failed");
      }
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleLogout}
      disabled={isLoading}
      className="mb-5 flex p-2 mx-2 gap-3 ps-2 items-center custom-text-size transition-all duration-200 hover:scale-105 hover:font-semibold hover:text-gray-800 rounded-md hover:bg-gray-50 hover:shadow-md"
    >
      <LogOut className="h-4 w-4" />
      {isLoading ? t("loggingOut") : t("logout")}
    </button>
  );
}
